export default "__VITE_ASSET__D1J1xKug__"